import { apiSlice } from "../api/apiSlice.js";
import { userLoggedIn, userLoggedOut, userRegistration, updateUser } from "./authSlice.js";
import { toast } from 'react-toastify';
import CryptoJS from "crypto-js";

const secretKey = "EcoClubsForMissionLiFEAICTEADMIN1@1234SecretKey";  // This should be stored securely, not hardcoded in production!

// Decrypt the password function
const decryptPassword = (encryptedUser) => {
  if (!encryptedUser) return null;
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedUser, secretKey);
    const decryptedStr = bytes.toString(CryptoJS.enc.Utf8);
    if (!decryptedStr) return null;
    return JSON.parse(decryptedStr);
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // endpoints here
    register: builder.mutation({
      query: (data) => ({
        url: "registration",
        method: "POST",
        body: data,
        credentials: "include",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          dispatch(
            userRegistration({
              token: result.data.activationToken,
            })
          );
        } catch (error) {
          console.log(error);
        }
      },
    }),
    activation: builder.mutation({
      query: ({ activation_token, activation_code }) => ({
        url: "activate-user",
        method: "POST",
        body: {
          activation_token,
          activation_code,
        },
      }),
    }),
    login: builder.mutation({
      query: ({ udise_id, activation_code: password, role, activation_token: token, captchaId, captchaAnswer, authToken, isPassword }) => {
        // const authToken = generateToken(); // Generate token for each request
        return {
          url: "school-login",
          method: "POST",
          body: {
            udise_id,
            activation_code: password,
            role,
            activation_token: token,
            captchaId,
            captchaAnswer,
            authToken, // Include token in request,
            isPassword
          },
          credentials: "include",
        };
      },
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          console.log("oooooooooooooooooo", result)
          const userdata = decryptPassword(result?.data?.user)
          console.log('🔍 [DEBUG] Decrypted userdata:', userdata);
          console.log('🔍 [DEBUG] userdata.school_type:', userdata?.school_type);

          if (!userdata) {
            toast.error("Failed to process user data. Please try logging in again.");
            return;
          }

          // Validate response token
          // if (!validateResponseToken(result.data.authToken, arg.authToken)) {
          //   throw new Error('Invalid or expired token in response');
          // }

          dispatch(
            userLoggedIn({
              accessToken: result.data.accessToken,
              user: userdata,
              lang: userdata?.lang || "en-IN"
            })
          );
        } catch (error) {
          console.log('111111111111111111111eeeeeeeeeeeeeeeeee', error);

          const errorData = error?.error?.data || error?.data;
          const errorMessage = errorData?.message || "Login failed. Please try again.";

          const displayMsg = errorMessage === "Incorrect or Expired activation code" ? "Invalid OTP" :
            errorMessage === "Invalid CAPTCHA ID" ? "Invalid Captcha" :
              errorMessage;
          
          if (typeof displayMsg === 'string') {
            toast.error(displayMsg);
          } else {
            toast.error("Login failed. Please try again.");
          }
        }
      },
    }),
    facultyLogin: builder.mutation({
      query: ({ udise_id, emailOrMobile, activation_code, role, activation_token, captchaId, captchaAnswer, authToken }) => {
        // const authToken = generateToken(); // Generate token for each request
        return {
          url: "faculty-login",
          method: "POST",
          body: {
            udise_id,
            emailOrMobile,
            activation_code,
            role: 3,
            activation_token,
            captchaId,
            captchaAnswer,
            authToken // Include token in request
          },
          credentials: "include",
        };
      },
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;

          // Validate response token
          // if (!validateResponseToken(result.data.authToken, arg.authToken)) {
          //   throw new Error('Invalid or expired token in response');
          // }
          const user = decryptPassword(result.data.user)

          if (!user) {
            toast.error("Failed to process user data. Please try logging in again.");
            return;
          }

          dispatch(
            userLoggedIn({
              accessToken: result.data.accessToken,
              user: user,
              lang: user?.lang || "en-IN"
            })
          );
        } catch (error) {
          console.log(error);
          const errorMsg = error?.error?.data?.message || error?.data?.message || "Faculty login failed";
          if (typeof errorMsg === 'string') {
            toast.error(errorMsg);
          } else {
            toast.error("Faculty login failed");
          }
        }
      },
    }),

    adminLogin: builder.mutation({
      query: ({ username, password, role, captchaId, captchaAnswer, authToken }) => {
        // const authToken = generateToken(); // Generate token for each request
        return {
          url: "admin-login",
          method: "POST",
          body: {
            username,
            password,
            role: role || 1,
            captchaId,
            captchaAnswer,
            authToken // Include token in request
          },
          credentials: "include",
        };
      },
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          console.log("Admin login attempt initiated.");
          const result = await queryFulfilled;
          const user = decryptPassword(result.data.user)

          if (!user) {
            toast.error("Failed to process user data. Please try logging in again.");
            return;
          }

          // Validate response token
          // if (!validateResponseToken(result.data.authToken, arg.authToken)) {
          //   throw new Error('Invalid or expired token in response');
          // }

          dispatch(
            userLoggedIn({
              accessToken: result.data.accessToken,
              user: user,
              lang: user?.lang || "en-IN"
            })
          );
        } catch (error) {
          console.log(error);
          const errorMsg = error?.error?.data?.message || error?.data?.message || "Admin login failed";
          if (typeof errorMsg === 'string') {
            toast.error(errorMsg);
          } else {
            toast.error("Admin login failed");
          }
        }
      },
    }),

    stateLogin: builder.mutation({
      query: ({ username, password, role, captchaId, captchaAnswer, authToken }) => {
        // const authToken = generateToken(); // Generate token for each request
        return {
          url: "admin-login",
          method: "POST",
          body: {
            username,
            password,
            role: 4,
            captchaId,
            captchaAnswer,
            authToken // Include token in request
          },
          credentials: "include",
        };
      },
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          console.log("state login attempt initiated.");
          const result = await queryFulfilled;
          const user = decryptPassword(result.data.user)

          console.log('200000000066', user);
          console.log('20000000777777777777', result);

          if (!user) {
            toast.error("Failed to process user data. Please try logging in again.");
            return;
          }

          // Validate response token
          // if (!validateResponseToken(result.data.authToken, arg.authToken)) {
          //   throw new Error('Invalid or expired token in response');
          // }

          dispatch(
            userLoggedIn({
              accessToken: result.data.accessToken,
              user: user,
              lang: user?.lang || "en-IN"
            })
          );
        } catch (error) {
          console.log(error);
          const errorMsg = error?.error?.data?.message || error?.data?.message || "State login failed";
          if (typeof errorMsg === 'string') {
            toast.error(errorMsg);
          } else {
            toast.error("State login failed");
          }
        }
      },
    }),




    socialAuth: builder.mutation({
      query: ({ email, name, avatar }) => ({
        url: "social-auth",
        method: "POST",
        body: {
          email,
          name,
          avatar,
        },
        credentials: "include",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          dispatch(
            userLoggedIn({
              accessToken: result.data.accessToken,
              user: result.data.user,
              lang: result.data.user.lang
            })
          );
        } catch (error) {
          console.log(error);
        }
      },
    }),
    logOut: builder.query({
      query: () => ({
        url: "logout",
        method: "GET",
        credentials: "include",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          dispatch(
            userLoggedOut()
          );
        } catch (error) {
          console.log(error);
        }
      },
    }),
    submitHealthyPledge: builder.mutation({
      query: (data) => ({
        url: "submit-healthy-pledge",
        method: "POST",
        body: data,
        credentials: "include",
      }),
      invalidatesTags: ['HealthyPledge'],
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toast.success("Pledge submitted successfully for Adopt Healthy Lifestyle!");
        } catch (error) {
          console.log(error);
          const errorMsg = error?.error?.data?.message || error?.data?.message || "Failed to submit pledge";
          if (typeof errorMsg === 'string') {
            toast.error(errorMsg);
          } else {
            toast.error("Failed to submit pledge");
          }
        }
      },
    }),
    checkHealthyPledge: builder.query({
      query: () => ({
        url: "check-healthy-pledge",
        method: "GET",
        credentials: "include",
      }),
      providesTags: ['HealthyPledge'],
    }),
    getHealthyPledge: builder.query({
      query: () => ({
        url: "get-healthy-pledge",
        method: "GET",
        credentials: "include",
      }),
      providesTags: ['HealthyPledge'],
    }),
    getHealthyPledgeStats: builder.query({
      query: () => ({
        url: "healthy-pledge-stats",
        method: "GET",
      }),
    }),

    // Mandatory Ek Ped Maa Ke Naam 3.0 popup gate. Uses `ekpedmaakenaam3-count`
    // (which is deployed) rather than `ekpedmaakenaam3-exists` — the latter isn't
    // on the production backend yet, so it 404'd and the popup never appeared.
    // `-count` returns { success, trees, eventCount, from }: eventCount>0 tells us
    // the school already has a 3.0 record (→ "update" flow), and `trees` gives the
    // real running total for the popup. UDISE + campaign resolve server-side from
    // the session, so no body is sent.
    checkEkped3Event: builder.query({
      query: () => ({
        url: "ekpedmaakenaam3-count",
        method: "POST",
        credentials: "include",
      }),
      // Fetch once per login and reuse the cached result everywhere (gate,
      // dashboard card, update-form prefill). Keep it cached for the whole session
      // so navigation doesn't re-hit the DB; it only re-runs after a submit
      // (explicit refetch) or a full reload.
      keepUnusedDataFor: 3600,
    }),

    // ── Swachhata Hi Seva: Solid Waste Management Drive ──────────────────────
    // Post-login campaign information + 10-question quiz. UDISE resolves
    // server-side from the session; bodies are AES-wrapped by the global
    // transport patch like every other POST.
    getSwachhataStatus: builder.query({
      query: () => ({
        url: "swachhata/status",
        method: "POST",
        credentials: "include",
      }),
      providesTags: ["Swachhata"],
      keepUnusedDataFor: 3600,
    }),
    markSwachhataInfo: builder.mutation({
      query: (data) => ({
        url: "swachhata/info-read",
        method: "POST",
        body: data || { event: "open" },
        credentials: "include",
      }),
    }),
    startSwachhataQuiz: builder.mutation({
      query: (data) => ({
        url: "swachhata/quiz/start",
        method: "POST",
        body: data && Object.keys(data).length ? data : { start: "1" },
        credentials: "include",
      }),
    }),
    // Public STUDENT flow (landing-page marquee → /swachhata-hi-seva). No login;
    // attempts are keyed by the attemptId returned from `start`.
    lookupSwachhataSchool: builder.mutation({
      query: (data) => ({ url: "swachhata/public/lookup-school", method: "POST", body: data }),
    }),
    startSwachhataStudentQuiz: builder.mutation({
      query: (data) => ({ url: "swachhata/public/student/start", method: "POST", body: data }),
    }),
    getSwachhataStudentAttempt: builder.mutation({
      query: (data) => ({ url: "swachhata/public/student/attempt", method: "POST", body: data }),
    }),
    submitSwachhataStudentQuiz: builder.mutation({
      query: (data) => ({ url: "swachhata/public/student/submit", method: "POST", body: data }),
    }),
    // Participation certificates. The id is issued server-side with the quiz
    // result (participation.certificate / attempt.certificate); these only
    // count a download and verify a printed / QR-scanned id.
    markSwachhataStudentCertificateDownloaded: builder.mutation({
      query: (data) => ({ url: "swachhata/public/student/certificate-downloaded", method: "POST", body: data }),
    }),
    // Public school-report showcase (/swachhata-hi-seva/school-reports). No login.
    getSwachhataPublicReportStats: builder.query({
      query: (params) => ({ url: "swachhata/public/reports/stats", method: "POST", body: params || {} }),
    }),
    getSwachhataPublicReportSchools: builder.query({
      query: (params) => ({ url: "swachhata/public/reports/schools", method: "POST", body: params || { page: 1 } }),
    }),
    // Public e-waste events (/swachhata-hi-seva/e-waste-events). No login.
    getEwastePublicStats: builder.query({
      query: (params) => ({ url: "swachhata/public/ewaste/stats", method: "POST", body: params || {} }),
    }),
    getEwastePublicSchools: builder.query({
      query: (params) => ({ url: "swachhata/public/ewaste/schools", method: "POST", body: params || { page: 1 } }),
    }),
    verifySwachhataCertificate: builder.mutation({
      query: (data) => ({ url: "swachhata/public/verify-certificate", method: "POST", body: data }),
    }),
    // Special Campaign 6 (E-Waste) — public school upload (/special-campaign-6). No login.
    lookupSc6School: builder.mutation({
      query: (data) => ({ url: "sc6/public/lookup-school", method: "POST", body: data }),
    }),
    submitSc6Report: builder.mutation({
      query: (data) => ({ url: "sc6/public/submit", method: "POST", body: data }),
    }),
    // Logged-in school: own saved upload (prefill) + full edit from the
    // dashboard. A save patches the login status (`sc6`) in place.
    getSc6SchoolReport: builder.query({
      query: () => ({ url: "sc6/school/report", method: "POST", credentials: "include" }),
      keepUnusedDataFor: 60,
    }),
    submitSc6SchoolReport: builder.mutation({
      query: (data) => ({ url: "sc6/school/submit", method: "POST", body: data, credentials: "include" }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data?.sc6) {
            dispatch(authApi.util.updateQueryData("getSwachhataStatus", undefined, (draft) => {
              if (draft) draft.sc6 = data.sc6;
            }));
          }
        } catch (e) {
          /* the form shows the error */
        }
      },
    }),
    markSwachhataCertificateDownloaded: builder.mutation({
      query: (data) => ({
        url: "swachhata/certificate/downloaded",
        method: "POST",
        body: { downloaded: "1", format: data?.format || "png" },
        credentials: "include",
      }),
    }),
    // School's view of its students' participation in the public quiz (no marks).
    getSwachhataSchoolStudents: builder.query({
      query: (params) => ({ url: "swachhata/school/students", method: "POST", body: params || { page: 1 }, credentials: "include" }),
      providesTags: ["SwachhataStudents"],
    }),
    submitSwachhataQuiz: builder.mutation({
      query: (data) => ({
        url: "swachhata/quiz/submit",
        method: "POST",
        body: data,
        credentials: "include",
      }),
      invalidatesTags: ["Swachhata"],
    }),
    // School SWM report (Swachhata Hi Seva 2026 form) — create or update. The
    // response carries the refreshed participation (survey + certificate).
    submitSwachhataSurvey: builder.mutation({
      query: (data) => ({
        url: "swachhata/survey/submit",
        method: "POST",
        body: data,
        credentials: "include",
      }),
      invalidatesTags: ["Swachhata"],
    }),
    // E-Waste Collection Drive — school report. "Filled or not" comes back on
    // getSwachhataStatus (`ewaste`); the saved report is fetched ONLY when the
    // school opens the form to update it. A save patches both caches in place
    // (no refetch).
    getEwasteReport: builder.query({
      query: () => ({ url: "swachhata/ewaste/report", method: "POST", credentials: "include" }),
      keepUnusedDataFor: 300,
    }),
    submitEwasteReport: builder.mutation({
      query: (data) => ({ url: "swachhata/ewaste/submit", method: "POST", body: data, credentials: "include" }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data?.ewaste) {
            dispatch(authApi.util.updateQueryData("getSwachhataStatus", undefined, (draft) => {
              if (draft) draft.ewaste = data.ewaste;
            }));
          }
          if (data?.report) {
            dispatch(authApi.util.updateQueryData("getEwasteReport", undefined, (draft) => {
              if (draft) draft.report = data.report;
            }));
          }
        } catch (e) {
          /* the form shows the error */
        }
      },
    }),
    // BRICS Sustainable Lifestyle Week (BSLW) 2026
    getBricsReport: builder.query({
      query: () => ({ url: "school/brics/report", method: "POST", credentials: "include" }),
      keepUnusedDataFor: 300,
    }),
    submitBricsSaveEnergy: builder.mutation({
      query: (data) => ({ url: "school/brics/save-energy/submit", method: "POST", body: data, credentials: "include" }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data?.report) {
            dispatch(authApi.util.updateQueryData("getBricsReport", undefined, (draft) => {
              if (draft) {
                draft.report = data.report;
                if (!draft.status) draft.status = {};
                draft.status.saveEnergySubmitted = true;
              }
            }));
          }
        } catch (e) {
          /* handled in component */
        }
      },
    }),
    lookupBricsSchool: builder.mutation({
      query: (data) => ({ url: "brics/public/lookup-school", method: "POST", body: data }),
    }),
    submitPublicBricsSaveEnergy: builder.mutation({
      query: (data) => ({ url: "brics/public/save-energy/submit", method: "POST", body: data }),
    }),
    submitPublicBricsHealthyLifestyle: builder.mutation({
      query: (data) => ({ url: "brics/public/adopt-healthy-lifestyle/submit", method: "POST", body: data }),
    }),
    submitBricsHealthyLifestyle: builder.mutation({
      query: (data) => ({ url: "school/brics/adopt-healthy-lifestyle/submit", method: "POST", body: data, credentials: "include" }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data?.report) {
            dispatch(authApi.util.updateQueryData("getBricsReport", undefined, (draft) => {
              if (draft) {
                draft.report = data.report;
                if (!draft.status) draft.status = {};
                draft.status.adoptHealthyLifestyleSubmitted = true;
              }
            }));
          }
        } catch (e) {
          /* handled in component */
        }
      },
    }),

    // The 7-question School Reporting form. The response carries the whole
    // report back, so the cached copy is patched instead of refetched.
    // No login: the UDISE rides in the body. The server lets the public route
    // send the report once and refuses later edits (BRICS_LOGIN_TO_EDIT).
    submitPublicBricsWeekReport: builder.mutation({
      query: (data) => ({ url: "brics/public/week-report/submit", method: "POST", body: data }),
    }),

    submitBricsWeekReport: builder.mutation({
      query: (data) => ({ url: "school/brics/week-report/submit", method: "POST", body: data, credentials: "include" }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data?.report) {
            dispatch(authApi.util.updateQueryData("getBricsReport", undefined, (draft) => {
              if (draft) {
                draft.report = data.report;
                if (!draft.status) draft.status = {};
                draft.status.weekReportSubmitted = true;
              }
            }));
          }
        } catch (e) {
          /* handled in component */
        }
      },
    }),

  }),
});

export const {
  useSubmitBricsWeekReportMutation,
  useSubmitPublicBricsWeekReportMutation,
  useGetBricsReportQuery,
  useSubmitBricsSaveEnergyMutation,
  useSubmitBricsHealthyLifestyleMutation,
  useLookupBricsSchoolMutation,
  useSubmitPublicBricsSaveEnergyMutation,
  useSubmitPublicBricsHealthyLifestyleMutation,
  useRegisterMutation,
  useActivationMutation,
  useLoginMutation,
  useFacultyLoginMutation,
  useAdminLoginMutation,
  useStateLoginMutation,
  useSocialAuthMutation,
  useLogOutQuery,
  useSubmitHealthyPledgeMutation,
  useCheckHealthyPledgeQuery,
  useGetHealthyPledgeQuery,
  useGetHealthyPledgeStatsQuery,
  useCheckEkped3EventQuery,
  useGetSwachhataStatusQuery,
  useMarkSwachhataInfoMutation,
  useStartSwachhataQuizMutation,
  useSubmitSwachhataQuizMutation,
  useSubmitSwachhataSurveyMutation,
  useGetSwachhataSchoolStudentsQuery,
  useLookupSwachhataSchoolMutation,
  useLookupSc6SchoolMutation,
  useSubmitSc6ReportMutation,
  useGetSc6SchoolReportQuery,
  useSubmitSc6SchoolReportMutation,
  useStartSwachhataStudentQuizMutation,
  useGetSwachhataStudentAttemptMutation,
  useSubmitSwachhataStudentQuizMutation,
  useMarkSwachhataStudentCertificateDownloadedMutation,
  useVerifySwachhataCertificateMutation,
  useGetSwachhataPublicReportStatsQuery,
  useGetSwachhataPublicReportSchoolsQuery,
  useMarkSwachhataCertificateDownloadedMutation,
  useGetEwasteReportQuery,
  useSubmitEwasteReportMutation,
  useGetEwastePublicStatsQuery,
  useGetEwastePublicSchoolsQuery,
} = authApi;
